module.exports = __webpack_public_path__ + "img/hierarchy-2.d09358b5.svg";